import React from 'react';
import { Mail, Phone, MapPin, Linkedin, MessageCircle, Instagram, Facebook } from 'lucide-react';

const footerLinks = [
  {
    heading: 'Daikin VRV',
    links: [
      { label: 'Daikin VRV Systems', href: '/daikin-vrv-systems' },  
      { label: 'Daikin VRV Dealer Delhi', href: '/daikin-vrv-dealer-delhi' },
      { label: 'Daikin VRV Dealer Noida', href: '/daikin-vrv-dealer-noida' },
      { label: 'Daikin VRV Dealer Gurgaon', href: '/daikin-vrv-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Split AC',
    links: [
      { label: 'Daikin Split AC Delhi', href: '/daikin-split-ac-dealer-delhi' },
      { label: 'Daikin Split AC Noida', href: '/daikin-split-ac-dealer-noida' },
      { label: 'Daikin Split AC Gurgaon', href: '/daikin-split-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Cassette AC',
    links: [
      { label: 'Daikin Cassette Delhi', href: '/daikin-cassette-ac-dealer-delhi' },
      { label: 'Daikin Cassette Noida', href: '/daikin-cassette-ac-dealer-noida' },
      { label: 'Daikin Cassette Gurgaon', href: '/daikin-cassette-ac-dealer-gurgaon' },
      { label: 'O-General Cassette Delhi', href: '/o-general-cassette-ac-dealer-delhi' },
      { label: 'O-General Cassette Noida', href: '/o-general-cassette-ac-dealer-noida' },
      { label: 'O-General Cassette Gurgaon', href: '/o-general-cassette-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Ductable AC',
    links: [
      { label: 'Daikin Ductable Delhi', href: '/daikin-ductable-ac-dealer-delhi' },
      { label: 'Daikin Ductable Noida', href: '/daikin-ductable-ac-dealer-noida' },
      { label: 'Daikin Ductable Gurgaon', href: '/daikin-ductable-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Window AC',
    links: [
      { label: 'O-General Window AC Delhi', href: '/o-general-window-ac-dealer-delhi' },
      { label: 'O-General Window AC Noida', href: '/o-general-window-ac-dealer-noida' },
      { label: 'O-General Window AC Gurgaon', href: '/o-general-window-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Industrial AC',
    links: [
      { label: 'Industrial AC Delhi', href: '/daikin-industrial-ac-dealer-delhi' },
      { label: 'Industrial AC Noida', href: '/daikin-industrial-ac-dealer-noida' },
      { label: 'Industrial AC Gurgaon', href: '/daikin-industrial-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Chillers',
    links: [
      { label: 'Daikin Chiller Delhi', href: '/daikin-chiller-dealer-delhi' },
      { label: 'Daikin Chiller Noida', href: '/daikin-chiller-dealer-noida' },
      { label: 'Daikin Chiller Gurgaon', href: '/daikin-chiller-dealer-gurgaon' },
    ],
  },
  {
    heading: 'O-General AC',
    links: [
      { label: 'O-General Dealer Delhi', href: '/o-general-dealer-delhi' },
      { label: 'O-General Dealer Noida', href: '/o-general-dealer-noida' },
      { label: 'O-General Dealer Gurgaon', href: '/o-general-dealer-gurgaon' },
      { label: 'O-General Split AC Delhi', href: '/o-general-split-ac-dealer-delhi' },
      { label: 'O-General Split AC Noida', href: '/o-general-split-ac-dealer-noida' },
      { label: 'O-General Split AC Gurgaon', href: '/o-general-split-ac-dealer-gurgaon' },
    ],
  },
  {
    heading: 'Daikin Dealer',
    links: [
      { label: 'Daikin Dealer Delhi', href: '/daikin-dealer-delhi' },
      { label: 'Daikin Dealer Noida', href: '/daikin-dealer-noida' },
      { label: 'Daikin Dealer Gurgaon', href: '/daikin-dealer-gurgaon' },
      { label: 'Daikin Dealer Faridabad', href: '/daikin-dealer-faridabad' },
    ],
  },
  {
    heading: 'HVAC Contractor',
    links: [
      { label: 'HVAC Contractor Delhi', href: '/hvac-contractor-delhi' },
      { label: 'HVAC Contractor Noida', href: '/hvac-contractor-noida' },
      { label: 'HVAC Contractor Gurgaon', href: '/hvac-contractor-gurgaon' },
      { label: 'VRV AC Installation', href: '/vrv-ac-installation' },
      { label: 'Split AC Installation', href: '/split-ac-installation' },
      { label: 'Cassette AC Installation', href: '/cassette-ac-installation' },
      { label: 'Ductable AC Installation', href: '/ductable-ac-installation' },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">

        {/* Top: Brand + Quick Links + Contact */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="/media/3pnsouhi-logo-final-20251216.webp"
              alt="Citi Cool Corporation"
              className="h-12 w-auto mb-4 brightness-200"
            />
            <p className="text-sm text-gray-400 leading-relaxed mb-4">
              Authorized Daikin, O-General, Hitachi and Mitsubishi Heavy Industries dealer providing premium HVAC solutions across Delhi NCR since 1990. Your trusted #1 HVAC dealer in North India.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/citicool/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
               href="https://wa.me/message/X4OR7NTM36W5M1"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-green-400 transition-colors"
                aria-label="WhatsApp"
                onClick={(e) => {
                  e.preventDefault();
                  const url = 'https://wa.me/message/X4OR7NTM36W5M1';
                  if (window.gtagSendEvent) window.gtagSendEvent(url);
                  else window.open(url, '_blank');
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                </svg>
              </a>
              <a
                href="https://www.instagram.com/citicoolindia"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-pink-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61582201197741"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-blue-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { label: 'Home', href: '/#home' },
                { label: 'Services', href: '/#services' },
                { label: 'VRV Systems', href: '/daikin-vrv-systems' },
                { label: 'HVAC Design', href: '/hvac-consultant' },
                { label: 'Architect Corner', href: '/architects-interior-designers' },
                { label: 'AC Calculator', href: '/ac-calculator' },
                { label: 'AC Guides', href: '/blog' },
                { label: 'Projects', href: '/#projects' },
                { label: 'About Us', href: '/about' },
                { label: 'Clients', href: '/#clients' },
                { label: 'Contact', href: '/contact' },
                { label: 'Privacy Policy', href: '/privacy-policy' },
                { label: 'Terms & Conditions', href: '/terms-and-conditions' },
                { label: 'Refund Policy', href: '/refund-policy' },
                { label: 'Delivery Policy', href: '/delivery-policy' },
              ].map((link) => (
                <li key={link.href}>
                  <a href={link.href} className="text-sm hover:text-blue-400 transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-blue-400 mt-1 flex-shrink-0" />
                <a 
                  href="tel:+917703900307" 
                  className="text-sm hover:text-blue-300 transition-colors"
                  onClick={(e) => {
                    e.preventDefault();
                    if (window.gtagSendEvent) window.gtagSendEvent('tel:+917703900307');
                    else window.location.href = 'tel:+917703900307';
                  }}
                >
                  +91 77039 00307
                </a>
              </li>
              <li className="flex items-start gap-2">
                <Phone size={16} className="text-blue-400 mt-1 flex-shrink-0" />
                <a href="tel:+919599083770" className="text-sm hover:text-blue-300 transition-colors">
                  Service & repairs: +91 95990 83770
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MessageCircle size={16} className="text-green-400 mt-1 flex-shrink-0" />
                <a
                  href="https://api.whatsapp.com/send?phone=917703900307&text=Hi%20Citi%20Cool%2C%20I%20need%20a%20quote"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:text-green-400 transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  const url = 'https://api.whatsapp.com/send?phone=917703900307&text=Hi%20Citi%20Cool%2C%20I%20need%20a%20quote';
                  if (window.gtagSendEvent) window.gtagSendEvent(url);
                  else window.open(url, '_blank');
                }}
              >
                WhatsApp Us
              </a>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={16} className="text-blue-400 mt-1 flex-shrink-0" />
                <a href="mailto:admin@citicool.in" className="text-sm hover:text-blue-400 transition-colors">
                  admin@citicool.in
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} className="text-blue-400 mt-1 flex-shrink-0" />
                <a
                  href="https://maps.google.com/?q=28.5623780523548,77.2208432826186"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm hover:text-blue-400 transition-colors"
                >
                  13 Jain Mandir Market, South Extension Part 2, New Delhi – 110049
                </a>
              </li>
            </ul>
          </div>

          {/* Certifications */}
          <div>
            <h3 className="text-white font-semibold mb-4">Awards & Recognition</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>🏆 #1 HVAC Dealer – North Region (Daikin India)</li>
              <li>🥇 MD Club Gold Member – Daikin India</li>
              <li>⭐ Quality Effort Award – Daikin India</li>
              <li>🏅 First Position Sales – Delhi Region</li>
              <li className="pt-2 text-gray-500">Authorized Dealer of Daikin, O-General and Mitsubishi Heavy Industries | Since 1990</li>
            </ul>
          </div>
        </div>

        {/* SEO Location Links Grid (Updated to lg:grid-cols-5 for 10 items) */}
        <div className="border-t border-gray-800 pt-10 mb-8">
          <h3 className="text-white font-semibold mb-6 text-sm uppercase tracking-wider">Service Areas & Products</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-6 gap-y-10">
            {footerLinks.map((group) => (
              <div key={group.heading}>
                <h4 className="text-gray-300 font-semibold text-xs uppercase tracking-wider mb-3">{group.heading}</h4>
                <ul className="space-y-1.5">
                  {group.links.map((link) => (
                    <li key={link.href}>
                      <a
                        href={link.href}
                        className="text-xs text-gray-500 hover:text-blue-400 transition-colors leading-snug block"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        
        {/* SEO Links Column (Add this to your Footer grid) */}
          <div>
            <h4 className="text-white font-bold mb-4">Areas We Serve</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="/daikin-vrv-dealer-delhi" className="hover:text-blue-400">Daikin VRV Delhi</a></li>
              <li><a href="/daikin-vrv-dealer-gurgaon" className="hover:text-blue-400">Daikin VRV Gurgaon</a></li>
              <li><a href="/hvac-contractor-noida" className="hover:text-blue-400">HVAC Contractor Noida</a></li>
              <li><a href="/daikin-dealer-faridabad" className="hover:text-blue-400">Daikin Dealer Faridabad</a></li>
              <li><a href="/daikin-industrial-ac-dealer-delhi" className="hover:text-blue-400">Industrial AC Delhi</a></li>
              <li><a href="/o-general-cassette-ac-dealer-gurgaon" className="hover:text-blue-400">O-General Cassette Gurgaon</a></li>
              <li><a href="/vrv-ac-installation" className="hover:text-blue-400">VRV AC Installation</a></li>
            </ul>
          </div>

        

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center space-y-3">
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2">
            {[
              { label: 'Terms & Conditions', href: '/terms-and-conditions' },
              { label: 'Refund & Cancellation Policy', href: '/refund-policy' },
              { label: 'Delivery Policy', href: '/delivery-policy' },
              { label: 'Privacy Policy', href: '/privacy-policy' },
              { label: 'Contact Us', href: '/#contact' },
            ].map((l) => (
              <a key={l.href} href={l.href} className="text-xs text-gray-400 hover:text-blue-400 transition-colors">
                {l.label}
              </a>
            ))}
          </div>
          <p className="text-sm text-gray-500">
            © {new Date().getFullYear()} Citi Cool Corporation. All rights reserved.
          </p>
          <p className="text-xs text-gray-600">
            Authorized Daikin, O-General, Hitachi and Mitsubishi Heavy Industries Dealer | 13 Jain Mandir Market, South Ex Part 2, New Delhi 110049
          </p>
        </div>
      </div>
    </footer>
  );
};